import { io } from "socket.io-client";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./useAuth";

const SocketContext = createContext(null);

const API_HOST = import.meta.env.VITE_API_URL || "http://localhost:30001";

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    // Only keep a live socket connection for signed-in users
    if (!isAuthenticated) {
      setSocket((prev) => {
        prev?.disconnect();
        return null;
      });
      return;
    }

    const newSocket = io(API_HOST, {
      transports: ["websocket"],
    });

    newSocket.on("connect", () => {
      const userId = user?.userId || user?.id || user?._id;
      if (userId) {
        newSocket.emit("registerUser", { userId });
      }
    });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, user?.userId, user?.id, user?._id]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
